/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved. */

/* This is relationship page user designed for dashboard */


/* `<dashboard-user-relationship>` shows aggregated balances on savings, loans, cards and investment type of accounts.

@demo bower_components/speedboat_ui/elements/demo/dashboard-user-relationship-demo.html
 */

/*  <link rel="import" href="dashboard-user-saving.html">
<link rel="import" href="dashboard-user-card.html">
<link rel="import" href="dashboard-user-loan.html">
<link rel="import" href="dashboard-user-investment.html">
<link rel="import" href="new-user-info-section.html">  */
import './dashboard-user-saving.js';
import './dashboard-user-card.js';
import './dashboard-user-loan.js';
import './dashboard-user-investment.js';
import { Polymer, html } from '@polymer/polymer/polymer-legacy.js';

const template = html `
		<style include="app-styles">
			.option-selected-s {
				color: var(--brand-color);
				font-size: var(--a-font-size-m);
				padding:16px 40px 32px 16px;
      		}
			
			:dir(rtl) .option-selected-s {
				color: var(--brand-color);
				font-size: var(--a-font-size-m);
				padding:16px 16px 32px 40px;
      		}
      
			.option-unselected-s {
				color: var(--disabled-dark-color);
				font-size: var(--a-font-size-m);
				padding:16px 40px 32px 16px;
			}
			
			:dir(rtl) .option-unselected-s {
				color: var(--disabled-dark-color);
				font-size: var(--a-font-size-m);
				padding:16px 16px 32px 40px;
			}

			.option-selected-s[tablet] {
				@apply --layout-horizontal;
				@apply --layout-center-justified;
				padding:16px 0px 32px 0px;
      		}
      
			.option-unselected-s[tablet] {
				@apply --layout-horizontal;
				@apply --layout-center-justified;
				padding:16px 0px 32px 0px;
			}

			::-webkit-scrollbar{
       			height:0px;
       			background: transparent;
     		}

			.image-div{
				background-size:100% 100%;
                min-height:212px;
                background-image: url("node_modules/speedboat_ui/images/sb_images/dashboard_bg.png");
			
			}

			.image-div[desktop]{
				min-height:100px;
			}
		
			@media only screen and (min-device-width : 320px) and (max-device-width : 767px){
				.image-div{
				        
			        	background-image: url("node_modules/speedboat_ui/images/sb_images/dashboard_bg_mobile.png");
		        	}
				.content-align-center-z-index{
					position: relative;
					top: 190px;
					z-index: 1;
				}
				.option-unselected-s,.option-selected-s{
					padding: 10px;
					position: relative;
					margin-left: 37.25%;
					margin-right: 37.25%;
				}
				.option-selected-s{
					background: var(--primary-light-color);
					border-radius: 24px;	
					box-shadow: 0px 5px 0px 0px rgba(0, 0, 0, 0.01), 0 6px 12px 0 rgba(0, 0, 0, 0.1);
					font-size: var(--a-font-size-s);
					padding: 10px 18px !important;
					margin-bottom: 15px;
				}
				.option-unselected-s{
					color:var(--brand-color);
					padding: 10px;
					position: relative;
					margin-left: 37.25%;
					margin-right: 37.25%;
					text-align: center;
					box-shadow: 0px 5px 0px 0px rgba(0, 0, 0, 0.01), 0 6px 12px 0 rgba(0, 0, 0, 0.1);
				}
				.leftarrow-bg, .rightarrow-bg{
					background: var(--primary-light-color);
					color: var(--brand-color);
					border-radius: 24px;
					width: var(--iron-icon-width, 30px);
    			height: var(--iron-icon-height, 30px);
				}
				.rightarrow-bg{
					position: absolute;
					right: 4.7%;
					top: 12%;
					box-shadow: 0px 5px 0px 0px rgba(0, 0, 0, 0.01), 0 6px 12px 0 rgba(0, 0, 0, 0.1);					
				}
				.leftarrow-bg{
					position: absolute;
					left: 4.7%;
					top: 12%;
					box-shadow: 0px 5px 0px 0px rgba(0, 0, 0, 0.01), 0 6px 12px 0 rgba(0, 0, 0, 0.1);					
				}
				.nextArrow  {
					position: absolute;
					right: 3%;
					top: 100%;
					font-size: var(--a-font-size-m);;
					color: var(--brand-color);
				}
				.preArrow{
					position: absolute;
					left: 3%;
					top: 100%;
					font-size: var(--a-font-size-m);;					
					color: var(--brand-color);
				}
				.image-accounts{
					background-size:100% 100%;
					min-height:212px;
				
				}
				.image-cards{
					background-size:100% 100%;
					min-height:212px;
				
				}
				.image-loans{
					background-size:100% 100%;
					min-height:212px;
				
				}
				.image-investments{
					background-size:100% 100%;
					min-height:212px;
				
        }
        .spinner-mobile{
          display:none;
        }
			}
            @supports(-ms-ime-align:auto){
                .mdl-cell.dashboard-user-relationship {
                    margin:8px 7px 8px 8px;
                }
            }
			

		</style>

		<sb-app-localstorage-document session-only key="myProfileSummary" data="{{myProfileSummaryData}}">
		</sb-app-localstorage-document>

		<app-media-query phone="{{phone}}" tablet="{{tablet}}" desktop="{{desktop}}"></app-media-query>

		<div hidden$={{!dashboardRelationshipLoader}}>
			<div class="image-div vertical center-center center-justified layout" desktop$="{{desktop}}">
				<paper-spinner id="dashboard_user_relationship_spinner" active class="spinner-mobile"></paper-spinner>
			</div>
		</div>	

    <div hidden$={{dashboardRelationshipLoader}}>
      <div class="image-div" id="imageDivId" desktop$="{{desktop}}">
        <div class="content-align-center-z-index" hidden$="{{desktop}}">
          <div class="flex-1 horizontal-scroll horizontal layout" id="dashboard_user_relationship_swipeDiv_menu">
            <iron-icon id="corporate-calendar-left-icon" class="outlineOffset leftarrow-bg" icon="icons:chevron-left" on-tap="_leftarrow" tabindex="0"></iron-icon>
            <div class="preArrow" aria-label$={{getLabel(preValue.value)}}><oe-i18n-msg msgid="[[preValue.value]]"></oe-i18n-msg></div>
            <div class$="outlineOffset text-transform-uppercase flex-1 option-selected-s {{selectedRelationshipObj.className}}" tablet$={{tablet}} some-item="{{selectedRelationshipObj}}" id="dashboard_user_relationship_swipeDiv_menu_item_{{index}}" data-item={{selectedRelationshipObj.index}} on-tap="_changeAccountType" tabindex="0">
                <oe-i18n-msg msgid="{{selectedRelationshipObj.value}}"></oe-i18n-msg>
            </div>
            <iron-icon id="corporate-calendar-right-icon" class="outlineOffset rightarrow-bg" icon="icons:chevron-right" on-tap="_rightarrow" tabindex="0"></iron-icon>
            <div class="nextArrow" aria-label$={{getLabel(nextValue.value)}}><oe-i18n-msg msgid="[[nextValue.value]]"></oe-i18n-msg></div>  
          </div>
        </div>
      <template is="dom-if" if="{{!desktop}}">
        <div class="mdl-grid padding-t-zero padding-b-zero" id="dashboard_user_relationship_swipeDiv">
          <div class="mdl-cell mdl-cell--12-col margin-b-zero margin-t-zero">
            <iron-pages selected="{{selectedrelationship}}">
              <div>
                <dashboard-user-saving selectedrelationship={{selectedrelationship}} savings={{savings}} savings-suggestions="{{savingsSuggestions}}"></dashboard-user-saving>
              </div>
              <div>
                <dashboard-user-card selectedrelationship={{selectedrelationship}} cards={{cards}} cards-suggestions="{{cardsSuggestions}}"></dashboard-user-card>
              </div>
              <div>
                <dashboard-user-loan selectedrelationship={{selectedrelationship}} loans={{loans}} loans-with-all-accounts={{loansWithAllAccounts}} loans-suggestions="{{loansSuggestions}}"></dashboard-user-loan>
              </div>
              <div>
                <dashboard-user-investment bonds={{bonds}} total-bonds={{totalBonds}} equity={{equity}} total-equity={{totalEquity}} selectedrelationship={{selectedrelationship}} investments={{investments}} investments-suggestions="{{investmentsSuggestions}}"></dashboard-user-investment>
              </div>
            </iron-pages>
          </div>
        </div>
      </template>
      
        <div role="menu" class="mdl-grid" hidden$="{{!desktop}}">
          <div tabindex="0" role="menuitem" class="outlineOffset mdl-cell mdl-cell--3-col content-align-horizonal-end border-r-1px" id="dashboard_relationship_desktop_0">
            <dashboard-user-saving primary-account-obj="{{primaryAccountObj}}" selectedrelationship={{selectedrelationship}} savings={{savings}} savings-suggestions="{{savingsSuggestions}}"></dashboard-user-saving>
          </div>
          
          <div tabindex="0" role="menuitem" class="outlineOffset mdl-cell mdl-cell--3-col content-align-horizonal-end border-r-1px" id="dashboard_relationship_desktop_1">
          <dashboard-user-card selectedrelationship={{selectedrelationship}} cards={{cards}} cards-suggestions="{{cardsSuggestions}}"></dashboard-user-card>
        </div>
        <div tabindex="0" role="menuitem" class="outlineOffset mdl-cell mdl-cell--3-col content-align-horizonal-end border-r-1px" id="dashboard_relationship_desktop_2">
        <dashboard-user-loan selectedrelationship={{selectedrelationship}} loans={{loans}} loans-with-all-accounts={{loansWithAllAccounts}} loans-suggestions="{{loansSuggestions}}"></dashboard-user-loan>
      </div>
          <div tabindex="0" role="menuitem" class="outlineOffset mdl-cell mdl-cell--3-col content-align-horizonal-end" id="dashboard_relationship_desktop_3">
            <dashboard-user-investment bonds={{bonds}} total-bonds={{totalBonds}} equity={{equity}} total-equity={{totalEquity}} selectedrelationship={{selectedrelationship}} investments={{investments}} investments-suggestions="{{investmentsSuggestions}}"></dashboard-user-investment>
          </div>
        
				</div>
			</div>

			<template is="dom-if" if="{{newUser}}">
				<div>
					<new-user-info-section></new-user-info-section>
				</div>
			</template>

		</div>`;
Polymer({
    is: 'dashboard-user-relationship',
    _template: template,
    properties: {
        selectedRelationshipObj: {
            type: Object,
            notify: true
        },
        selectedrelationship: {
            type: Number,
            notify: true
        },
        selectedTab: {
            type: Number,
            value: 0,
            notify: true,
            observer: '_changeSelectedRelationship'
        },
        savings: {
            type: Array,
            notify: true,
            observer: '_listChanged'
        },
        loans: {
            type: Array,
            notify: true,
            observer: '_listChanged'
        },
        imageBaseUrl: {
            type: String,
            value: window.OEUtils.uibaseroute
        },
        requests: {
            type: Array,
            notify: true,
            observer: '_listChanged'
        },
        cards: {
            type: Array,
            notify: true,
            observer: '_listChanged'
        },
        investments: {
            type: Array,
            notify: true,
            observer: '_listChanged'
        },
        dashboardRelationshipLoader: {
            type: Boolean,
            value: true,
            notify: true
        },
        dashboardRelationshipMenu: {
            type: Array,
            notify: true
        },
        newUser: {
            type: Boolean,
            value: false,
            notify: true
        },
        loansWithAllAccounts: {
            type: Array,
            notify: true
        },
        myProfileSummaryData: {
            type: Object,
            notify: true
        },

        /*getting list of bonds*/
        bonds: {
            type: Array,
            notify: true,
            observer: 'handleBonds'
        },

        /*getting sum of bonds*/
        totalBonds: {
            type: String,
            notify: true
        },
		primaryAccountObj: {
		  type: Object,
		  notify: true
		}
    },
    attached: function() {
       
      if (channelType.iphone || channelType.android) {
        var backgroundImgSrc1 = this.imageBaseUrl + "/node_modules/speedboat_ui/images/sb_images/dashboard_bg_mobile.png";
        document.querySelector('body').classList.add('device-phone');
         this.shadowRoot.querySelector("#imageDivId").style.backgroundImage = "url(" + backgroundImgSrc1 + ")";
      }
        if (!this.desktop) {
            swipe.checkSwipe(this.$$("#dashboard_user_relationship_swipeDiv"), this.handleSwipe, this);
        }
    },
    _changeSelectedRelationship: function() {
        if (this.selectedTab != undefined && this.dashboardRelationshipMenu != undefined) {
            this.selectedRelationshipObj = this.dashboardRelationshipMenu[this.selectedTab];
            this.selectedrelationship = this.dashboardRelationshipMenu[this.selectedTab].index;
        }
    },
    _listChanged: function() {
        if (this.savings && this.cards && this.investments && this.loans && this.requests) {
            var relationShipMenuWithValue = [];
            var relationShipMenuWithoutValue = [];
            var summaryData = {
                accounts: this.savings.length,
                deposits: this.investments.length,
                loans: this.loans.length,
                creditcards: this.cards.length,
                servicerequests: this.requests.length
            };
            this.myProfileSummaryData = {};
            this.myProfileSummaryData = summaryData;
            var accountList = [];
            accountList = accountList.concat(this.savings);
            accountList = accountList.concat(this.investments);
            accountList = accountList.concat(this.loans);
            accountList = accountList.concat(this.cards);
            clientStorage.set(storageType.session, 'accountList', accountList);
            var account = {
                index: 0,
                value: "h_Accounts",
                className: "option-unselected-s"
            };
            var card = {
                index: 1,
                value: "h_Cards",
                className: "option-unselected-s"
            };
            var loan = {
                index: 2,
                value: "h_Loans",
                className: "option-unselected-s"
            };
            var investment = {
                index: 3,
                value: "h_Investment",
                className: "option-unselected-s"
            };

            if (this.savings.length > 0) {
                relationShipMenuWithValue.push(account);
            } else {
                relationShipMenuWithoutValue.push(account);
            }

            if (this.cards.length > 0) {
                relationShipMenuWithValue.push(card);
            } else {
                relationShipMenuWithoutValue.push(card);
            }

            if (this.loans.length > 0) {
                relationShipMenuWithValue.push(loan);
            } else {
                relationShipMenuWithoutValue.push(loan);
            }

            if (this.investments.length > 0) {
                relationShipMenuWithValue.push(investment);
            } else {
                relationShipMenuWithoutValue.push(investment);
            }

            if (relationShipMenuWithoutValue.length > 0) {
                for (var i = 0; i < relationShipMenuWithoutValue.length; i++) relationShipMenuWithValue.push(relationShipMenuWithoutValue[i]);
            }
            for (var temp = 0; temp < relationShipMenuWithValue.length; temp++) {
                var tempid = "#dashboard_relationship_desktop_" + relationShipMenuWithValue[temp].index;
                var tempClass = "mdl-cell--order-" + temp;
                var tempClass1 = "border-r-1px";
                this.$$(tempid).classList.add(tempClass);

                if (temp !== relationShipMenuWithValue.length - 1)
                    this.$$(tempid).classList.add(tempClass1);

            }

            // create card element 
            //Reverting the changes as, Amount is not comming for Cards and Loans
            // var elementCard = document.createElement('dashboard-user-card');
            // elementCard.cards = this.cards;
            // elementCard.selectedrelationship = this.selectedrelationship; //create investment element 

            // var elementInvestMent = document.createElement('dashboard-user-investment');
            // elementInvestMent.bonds = this.bonds;
            // elementInvestMent.totalBonds = this.totalBonds;
            // elementInvestMent.equity = this.equity;
            // elementInvestMent.totalEquity = this.totalEquity;
            // elementInvestMent.selectedrelationship = this.selectedrelationship;
            // elementInvestMent.investments = this.investments;
            // elementInvestMent.investmentsSuggestions = this.investmentsSuggestions; //create loan element

            // var elementLoan = document.createElement('dashboard-user-loan');
            // elementLoan.selectedrelationship = this.selectedrelationship;
            // elementLoan.loans = this.loans;
            // elementLoan.loansWithAllAccounts = this.loansWithAllAccounts;
            // elementLoan.loansSuggestions = this.loansSuggestions; //create saving element

            // var elementSaving = document.createElement('dashboard-user-saving');
            // elementSaving.savings = this.savings;
            // elementSaving.selectedrelationship = this.selectedrelationship;
            // elementSaving.savingsSuggestions = this.savingsSuggestions;

            // for (var temp = 0; temp < relationShipMenuWithValue.length; temp++) {
            //   var div = document.createElement('div');
            //   div.classList = "mdl-cell mdl-cell--3-col content-align-horizonal-end border-r-1px";
            //   div.id = "dashboard_relationship_desktop_" + relationShipMenuWithValue[temp].index;

            //   if (relationShipMenuWithValue[temp].value == "h_Accounts") {
            //     div.appendChild(elementSaving);
            //     this.$$("#dashboard_relationship_desktop").appendChild(div);
            //   } else if (relationShipMenuWithValue[temp].value == "h_Cards") {
            //     div.appendChild(elementCard);
            //     this.$$("#dashboard_relationship_desktop").appendChild(div);
            //   } else if (relationShipMenuWithValue[temp].value == "h_Loans") {
            //     div.appendChild(elementLoan);
            //     this.$$("#dashboard_relationship_desktop").appendChild(div);
            //   } else if (relationShipMenuWithValue[temp].value == "h_Investment") {
            //     div.appendChild(elementInvestMent);
            //     this.$$("#dashboard_relationship_desktop").appendChild(div);
            //   }
            // } //change class of 1st element
            relationShipMenuWithValue[0].className = "option-selected-s";

            this.dashboardRelationshipMenu = relationShipMenuWithValue;

            this.selectedrelationship = this.dashboardRelationshipMenu[this.selectedTab].index;
            this.selectedRelationshipObj = this.dashboardRelationshipMenu[this.selectedTab];

            if (this.selectedTab > 0) {
                this.preValue = this.dashboardRelationshipMenu[this.selectedTab - 1];
            } else {
                this.preValue = this.dashboardRelationshipMenu[this.dashboardRelationshipMenu.length - 1];
            }
            if (this.selectedTab < this.dashboardRelationshipMenu.length - 1) {
                this.nextValue = this.dashboardRelationshipMenu[this.selectedTab + 1];
            } else {
                this.nextValue = 0;
            }
            //check new user
            if (this.cards.length == 0 && this.investments.length == 0 && this.loans.length == 0 && this.savings.length == 1) {
                account = this.savings[0];
                for (var j = 0; j < account.balances.length; j++) {
                    if (account.balances[j].type == "availableBalance" && Number(account.balances[j].amountDetails.amount) == 0) {
                        this.newUser = true;
                        break;
                    }
                }
            }

            this.$$("#dashboard_user_relationship_spinner").active = false;
            this.dashboardRelationshipLoader = false;
            //trigger an event 'dashboard-loaded' to indicate to other less-piority elemets to start loading. 
            //'go-to' is one such example which is loaded based on this event in header-panel.
            this.fire('dashboard-loaded');
        }
    },
    _changeAccountType: function(event) {
        var index = event.model.index;
        this._changeColorOfSelectedTab(index);
    },
    _changeColorOfSelectedTab: function(index) {
        for (var i = 0; i < this.dashboardRelationshipMenu.length; i++) {
            if (i == index)
                this.set('dashboardRelationshipMenu.' + i + '.className', 'option-selected-s');
            else
                this.set('dashboardRelationshipMenu.' + i + '.className', 'option-unselected-s');
        }
        if (this.selectedTab > index)
            this.scrollLeft(index);
        else
            this.scrollRight(index);
        this.selectedTab = index;
    },
    handleSwipe: function(val, self) {
        if (val == 'right') {
            if (self.selectedTab != 0) {
                let index = self.selectedTab - 1;
                self._changeColorOfSelectedTab(index);
            }
        } else if (val == 'left') {
            if (self.selectedTab != 3) {
                let index = self.selectedTab + 1;
                self._changeColorOfSelectedTab(index);
            }
        }
    },
    scrollLeft: function(index) {
        var id = "#dashboard_user_relationship_swipeDiv_menu_item_" + (index);
        var width = this.$$(id).offsetLeft - 48;
        this.$$("#dashboard_user_relationship_swipeDiv_menu").scrollLeft = width;
    },
    scrollRight: function(index) {
        var id = "#dashboard_user_relationship_swipeDiv_menu_item_" + index;
        var width = this.$$(id).offsetLeft;
        this.$$("#dashboard_user_relationship_swipeDiv_menu").scrollLeft = width;
    },
    //<!--Sandeep changes-->
      _rightarrow: function _rightarrow(event) {
      this.nextValue = "";
      this.preValue = this.dashboardRelationshipMenu[this.selectedTab];
      var backgroundImgSrc1 = this.imageBaseUrl + "/node_modules/speedboat_ui/images/sb_images/dashboard_bg_mobile.png";
      var backgroundImgSrc2 = this.imageBaseUrl + "/node_modules/speedboat_ui/images/sb_images/Background_2.png";
      var backgroundImgSrc3 = this.imageBaseUrl + "/node_modules/speedboat_ui/images/sb_images/Background_3.png";
      var backgroundImgSrc4 = this.imageBaseUrl + "/node_modules/speedboat_ui/images/sb_images/Background_4.png";

      if (this.selectedTab < this.dashboardRelationshipMenu.length - 1) {
        this.selectedTab += 1;
      } else {
        this.selectedTab = 0;
      }

      if (this.selectedTab == this.dashboardRelationshipMenu.length - 1) {
        this.nextValue = this.dashboardRelationshipMenu[0];
      } else {
        this.nextValue = this.dashboardRelationshipMenu[this.selectedTab + 1];
      } // console.log("NEXT" + this.nextValue.value);

       var presentValue =this.dashboardRelationshipMenu[this.selectedTab].value;
      if (presentValue=== 'h_Investment') {
        this.shadowRoot.querySelector("#imageDivId").classList.remove("image-div");
        this.shadowRoot.querySelector("#imageDivId").classList.remove("image-cards");
        this.shadowRoot.querySelector("#imageDivId").classList.remove("image-loans");
        this.shadowRoot.querySelector("#imageDivId").classList.remove("image-accounts");
        this.shadowRoot.querySelector("#imageDivId").classList.add("image-investments");
        this.shadowRoot.querySelector("#imageDivId").style.backgroundImage = "url(" + backgroundImgSrc4+ ")";
      } else if (presentValue=== 'h_Cards') {
        this.shadowRoot.querySelector("#imageDivId").classList.remove("image-div");
        this.shadowRoot.querySelector("#imageDivId").classList.remove("image-loans");
        this.shadowRoot.querySelector("#imageDivId").classList.remove("image-accounts");
        this.shadowRoot.querySelector("#imageDivId").classList.remove("image-investments");
        this.shadowRoot.querySelector("#imageDivId").classList.add("image-cards");
        this.shadowRoot.querySelector("#imageDivId").style.backgroundImage = "url(" + backgroundImgSrc2 + ")";
      } else if (presentValue === 'h_Loans') {
        this.shadowRoot.querySelector("#imageDivId").classList.remove("image-div");
        this.shadowRoot.querySelector("#imageDivId").classList.remove("image-accounts");
        this.shadowRoot.querySelector("#imageDivId").classList.remove("image-investments");
        this.shadowRoot.querySelector("#imageDivId").classList.remove("image-cards");
        this.shadowRoot.querySelector("#imageDivId").classList.add("image-loans");
        this.shadowRoot.querySelector("#imageDivId").style.backgroundImage = "url(" + backgroundImgSrc3 + ")";
      }
       else if (presentValue=== 'h_Accounts') {
              this.shadowRoot.querySelector("#imageDivId").classList.remove("image-investments");
              this.shadowRoot.querySelector("#imageDivId").classList.remove("image-cards");
              this.shadowRoot.querySelector("#imageDivId").classList.remove("image-loans");
              this.shadowRoot.querySelector("#imageDivId").classList.remove("image-div");
              this.shadowRoot.querySelector("#imageDivId").classList.add("image-accounts");

              this.shadowRoot.querySelector("#imageDivId").style.backgroundImage = "url(" + backgroundImgSrc1 + ")";
            }
    },
    _leftarrow: function _leftarrow(event) {
      this.preValue = "";
      var backgroundImgSrc1 = this.imageBaseUrl + "/node_modules/speedboat_ui/images/sb_images/dashboard_bg_mobile.png";
      var backgroundImgSrc2 = this.imageBaseUrl + "/node_modules/speedboat_ui/images/sb_images/Background_2.png";
      var backgroundImgSrc3 = this.imageBaseUrl + "/node_modules/speedboat_ui/images/sb_images/Background_3.png";
      var backgroundImgSrc4 = this.imageBaseUrl + "/node_modules/speedboat_ui/images/sb_images/Background_4.png";
      this.nextValue = this.dashboardRelationshipMenu[this.selectedTab];

      if (this.selectedTab > 0) {
        this.selectedTab -= 1;
      } else {
        this.selectedTab = this.dashboardRelationshipMenu.length - 1;
      }

      if (this.selectedTab == 0) {
        this.preValue = this.dashboardRelationshipMenu[this.dashboardRelationshipMenu.length - 1];
      } else {
        this.preValue = this.dashboardRelationshipMenu[this.selectedTab - 1];
      }
       var presentValue =this.dashboardRelationshipMenu[this.selectedTab].value;

      if (presentValue === 'h_Investment') {
        this.shadowRoot.querySelector("#imageDivId").classList.remove("image-div");
        this.shadowRoot.querySelector("#imageDivId").classList.remove("image-cards");
        this.shadowRoot.querySelector("#imageDivId").classList.remove("image-loans");
        this.shadowRoot.querySelector("#imageDivId").classList.remove("image-accounts");
        this.shadowRoot.querySelector("#imageDivId").classList.add("image-investments");
        this.shadowRoot.querySelector("#imageDivId").style.backgroundImage = "url(" + backgroundImgSrc4 + ")";
      } else if (presentValue === 'h_Cards') {
        this.shadowRoot.querySelector("#imageDivId").classList.remove("image-div");
        this.shadowRoot.querySelector("#imageDivId").classList.remove("image-loans");
        this.shadowRoot.querySelector("#imageDivId").classList.remove("image-accounts");
        this.shadowRoot.querySelector("#imageDivId").classList.remove("image-investments");
        this.shadowRoot.querySelector("#imageDivId").classList.add("image-cards");
        this.shadowRoot.querySelector("#imageDivId").style.backgroundImage = "url(" + backgroundImgSrc2 + ")";
      } else if (presentValue === 'h_Loans') {
        this.shadowRoot.querySelector("#imageDivId").classList.remove("image-div");
        this.shadowRoot.querySelector("#imageDivId").classList.remove("image-accounts");
        this.shadowRoot.querySelector("#imageDivId").classList.remove("image-investments");
        this.shadowRoot.querySelector("#imageDivId").classList.remove("image-cards");
        this.shadowRoot.querySelector("#imageDivId").classList.add("image-loans");
        this.shadowRoot.querySelector("#imageDivId").style.backgroundImage = "url(" + backgroundImgSrc3 + ")";
      } else if (presentValue=== 'h_Accounts') {
        this.shadowRoot.querySelector("#imageDivId").classList.remove("image-investments");
        this.shadowRoot.querySelector("#imageDivId").classList.remove("image-cards");
        this.shadowRoot.querySelector("#imageDivId").classList.remove("image-loans");
        this.shadowRoot.querySelector("#imageDivId").classList.remove("image-div");
        this.shadowRoot.querySelector("#imageDivId").classList.add("image-accounts");

        this.shadowRoot.querySelector("#imageDivId").style.backgroundImage = "url(" + backgroundImgSrc1 + ")";
      }
    }
  });
